import React from 'react';
import { CloseOutlineIcon } from 'cokitchen-icons';

type MetadataTagColor = 'red' | 'gray';
const MetadataTag = ({
  name,
  onDelete,
  onClick,
  color = 'gray',
  hasDeleteBtn = false
}: {
  name: string;
  onClick?: () => void;
  onDelete?: () => void;
  color?: MetadataTagColor;
  hasDeleteBtn?: boolean;
}) => {
  return (
    <li
      onClick={onClick}
      className={`text-sm leading-[19px] py-1 font-medium flex gap-1 items-center rounded-[100px] px-2 cursor-pointer ${
        color === 'gray' ? 'text-gray-5 bg-[#F2F2F3]' : 'border border-red-2 bg-red-9 text-red-5'
      }`}>
      <span className='capitalize'> {name}</span>
      {hasDeleteBtn && (
        <span
          role='button'
          onClick={(e) => {
            e.stopPropagation();
            onDelete?.();
          }}>
          <CloseOutlineIcon />
        </span>
      )}
    </li>
  );
};

export default MetadataTag;
